module.exports = __webpack_public_path__ + "img/dfm-box.70fec1ba.png";